import { Dispatch } from 'redux';
import { FederatedModules } from '../../types';
import { setDeviceId, setProductTeaser } from '../../redux/actions/appActions';
import MarketingContentService from '../../services/marketingContent.service';
import { getAirshipChannelId } from '../../utils/airshipHandler';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';
import { v4 as uuidv4 } from 'uuid';
import airshipService from '../../services/airship.service';
import { getLanguageFromLocalStorage } from '../../i18n';

export const getProductTeaserByProduct = (product: FederatedModules) => async (dispatch: Dispatch) => {
  const productTeaser = await MarketingContentService.getMarketingContent(product, 'PRODUCT_TEASER');
  dispatch(setProductTeaser(productTeaser));
};

export const createDeviceInfo = (isAuthenticatedAuth0: boolean) => async (dispatch: Dispatch) => {
  const deviceId = localStorage.getItem('device_id');
  const airshipChannelId = await getAirshipChannelId();
  const email = LocalAuth.getUser().email as string;
  const token = LocalAuth.getTokenValue();
  const language = getLanguageFromLocalStorage();
  if ((token || isAuthenticatedAuth0) && !deviceId) {
    try {
      const deviceId = uuidv4();
      await airshipService.createDeviceInfo(email, deviceId, language, airshipChannelId);
      localStorage.setItem('device_id', deviceId);
      dispatch(setDeviceId(deviceId));
    } catch (e) {
      console.log('Error while trying to process device information', e);
    }
  }
};
